<div style="display: flex; flex-direction: row; justify-content: space-between;"
    class="snack-container">
    <div>
        <mat-icon style="vertical-align: middle;margin-right: 8px;">{{getIcon}}</mat-icon>
        <span>{{data.message}}</span>
    </div>
    <div>
        <button mat-icon-button (click)="snackBarRef.dismiss()"><mat-icon color="white">close</mat-icon></button>
    </div>
</div>